module.exports = __webpack_public_path__ + "img/hand-tool.06ce8967.gif";